import steamToken from "../abis/production/tokens/steamToken";

export default {
  name: "STEAM",
  abi: steamToken.abi,
  contractAddress: "0x2453D2F8D853A23F6DBf76Be85De8df80eE6Ec2E",
  decimals: 9,
};
